// extracted by mini-css-extract-plugin
export default {"spin_layout":"styles_spin_layout__DTcRD"};